import type {Request} from 'express'
import {toClientGlobalPreferences} from '../context/global-preferences'
import {fetchPreferences, PreferencesResponse} from './fetchPreferences'

export type GlobalPreferencesResponse = PreferencesResponse

export const fetchGlobalCustomPreferences = async (
    req: Request
): Promise<GlobalPreferencesResponse> => {
    return fetchPreferences(req, 'global-custom-preferences', '', 'global')
}

export const getClientGlobalCustomPreferences = async (req: Request) => {
    const data = await fetchGlobalCustomPreferences(req)

    return toClientGlobalPreferences(data)
}
